export const MAIN_EMAIL = "Jamal@zgugu-group.uk";
export const PHONE = "+44 7778 686777";

export const PORTRAIT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_22945815-f946-4c72-b48a-a8a137f83fd7/artifacts/2b2ff582a7efc0a5_Gemini_Generated_Image_bwe6eebwe6eebwe6%20%281%29.jpeg";

export const IMAGES = {
  archive:
    "https://images.unsplash.com/photo-1588889802078-67ce0634a6a3?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  speaking:
    "https://images.unsplash.com/photo-1544531586-fde5298cdd40?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  cities:
    "https://images.pexels.com/photos/18341554/pexels-photo-18341554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CLIENTS = {
  en: [
    "PepsiCo",
    "Procter & Gamble (P&G)",
    "KFC",
    "McDonald’s",
    "IKEA",
    "Japan Tobacco Inc",
    "British American Tobacco",
    "Philip Morris International",
    "LG Corporation",
  ],
};

// Role data shared across languages; logo files live in /public/logos
export const ROLES = [
  {
    id: "naip",
    domain: "naip.ly",
    logo: "/logos/naip.png",
    title: { en: "Chairman of the Board", ar: "رئيس مجلس الإدارة" },
    name: {
      en: "North Africa Intellectual Property & Legal Consultancy",
      ar: "شمال أفريقيا للملكية الفكرية والاستشارات القانونية",
    },
  },
  {
    id: "gito",
    domain: "general-ito.com",
    logo: "/logos/gito.png",
    title: { en: "Chairman of the Board", ar: "رئيس مجلس الإدارة" },
    name: {
      en: "General Inspection Technical Office, London",
      ar: "المكتب الفني العام للتفتيش، لندن",
    },
  },
  {
    id: "alphagate",
    domain: "alphagate-ip.com",
    logo: "/logos/alphagate.jpg",
    fullBleed: true,
    title: { en: "General Manager", ar: "المدير العام" },
    name: {
      en: "ALPHA GATE TRADE MARK REGISTRATION L.L.C, UAE",
      ar: "ألفا غيت لتسجيل العلامات التجارية ذ.م.م، الإمارات",
    },
  },
  {
    id: "alkhabeer",
    domain: "alkhabeer-ic.com",
    logo: "/logos/alkhabeer.jpg",
    title: { en: "Manager", ar: "المدير" },
    name: {
      en: "Al Khabeer for Inspection and Conformity Company, Libya",
      ar: "شركة الخبير للتفتيش والمطابقة، ليبيا",
    },
  },
  {
    id: "atlas",
    domain: "atlasbridge.uk",
    logo: "/logos/atlas.png",
    title: { en: "General Manager", ar: "المدير العام" },
    name: { en: "Atlas Bridge Logistics", ar: "أطلس بريدج للخدمات اللوجستية" },
  },
  {
    id: "haliqgrey",
    domain: "haliqgrey.com",
    url: "http://haliqgrey.com",
    logo: "/logos/haliqgrey.png",
    wideLogo: true,
    title: { en: "Business Development Manager", ar: "مدير تطوير الأعمال" },
    name: { en: "Haliq & Grey", ar: "Haliq & Grey" },
  },
  {
    id: "lbc",
    domain: null,
    logo: null,
    title: { en: "Founding Member · since 2005", ar: "عضو مؤسس · منذ 2005" },
    name: { en: "Libyan Businessmen Council", ar: "مجلس رجال الأعمال الليبيين" },
  },
];

export const T = {
  en: {
    nav: { about: "About", roles: "Roles", credentials: "Credentials", contact: "Contact" },
    langSwitch: "العربية",
    heroLabel: "Intellectual property · London‑Dubai‑Libya",
    heroLines: ["Guarding the names", "the world trusts."],
    heroText:
      "Libya's first trademark registration agent, protecting multinational brands since 2002.",
    heroCta: "Contact Jamal",
    portraitCaption: "Jamal Zgugu",
    clientsLabel: "Safeguarding the intellectual property of",
    aboutLabel: "A first for Libya",
    archiveCaption: "Libya",
    milestoneHeadline: "The day intellectual property (IP) began in Libya.",
    milestoneSub: "The first trademark ever registered in Libya, introducing trademark protection to the country.",
    milestone:
      "The first Trademark Registration Agent in Libya and the first to successfully file and register a trademark with the Libyan Trademark Office on November 24, 2002.",
    milestoneNote:
      "This milestone contributed to the advancement of intellectual property rights and trademark protection in Libya.",
    profileLabel: "Profile",
    profile: [
      "Recognized as a leading professional in Intellectual Property Protection, Anti-Counterfeiting, and Brand Enforcement, with a proven track record in safeguarding the intellectual property rights and commercial interests of leading multinational corporations, including PepsiCo, Procter & Gamble (P&G), KFC, McDonald’s, and IKEA.",
      "Extensive professional experience spans intellectual property, trademark protection, legal and commercial consultancy, inspection and conformity, business development, logistics, and professional training, with a career spanning Libya, the United Kingdom, and the United Arab Emirates.",
    ],
    focusLabel: "Professional focus",
    focus: [
      "Intellectual property",
      "Trademarks",
      "Brand protection",
      "Anti-counterfeiting",
      "Legal & commercial consultancy",
      "Inspection & conformity",
      "Business development",
      "Professional training",
    ],
    rolesTitle: "Leadership",
    rolesIntro: "Professional leadership roles across Libya, the United Kingdom and the UAE.",
    visit: "Visit website",
    credTitle: "Trained in Geneva. Lecturing in Beirut.",
    credentials: [
      "Professional training in Intellectual Property, WIPO Academy, Geneva",
      "Certified lecturer, United Nations ESCWA, Beirut, and the Libyan Scientific Research Authority",
      "Bachelor’s degree in Economics of Developing Countries · Diploma in Law, Libya",
    ],
    speakingCaption: "Professional training",
    citiesCaption: "London‑Dubai‑Libya",
    contactLabel: "Based in London‑Dubai‑Libya · Arabic | English",
    contactTitle: "A conversation about your brand.",
    contactText: "For a specific company, write to Jamal at that company's address listed above.",
    footerRight: "Intellectual Property · Brand Enforcement",
  },
};
